import styled from "styled-components";

export const StyledImportPopoverLine = styled.div`
  border-top: 1px solid #d6d6d6;
  margin-bottom: 16px;
`;

export const StyledImportPopoverFileName = styled.div`
  color: #383538;
  font-size: 14px;
  padding: 15px 21px;
  font-weight: 500;
  background: #f8f8f8;
  border-radius: 3px;
  position: relative;
`;

export const StyledSearchBar = styled.div`
  position: absolute;
  top: 38px;
  left: 0px;
  width: 440px;
  padding: 12px;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  cursor: pointer;
  z-index: 10000;
  &:hover {
    background-color: #f7f1fe;
  }
`;

export const StyledBadge = styled.div`
  background-color: #fff;
  border: 1px solid #777777;
  border-radius: 20px;
  color: #777777;
  padding-inline: 8px;
  padding-block: 4px;
  font-size: 14px;
  font-weight: 500;
  text-transform: capitalize;
  cursor: pointer;

  &:hover {
    border-color: #7b61ff;
    color: #7b61ff;
  }

  &.disabled {
    background-color: #f8f8f8;
    border-color: #e6e6e6;
    color: rgba(0, 0, 0, 0.36);

    &:hover {
      cursor: not-allowed;
      color: rgba(0, 0, 0, 0.36);
    }
  }

  &.active {
    border-color: #7b61ff;
    background-color: #7b61ff;
    color: #fff;

    &:hover {
      color: #fff;
    }
  }
`;
